import * as React from 'react';
const TabsContext = React.createContext({
    variant: 'default'
});
export const TabsContextProvider = TabsContext.Provider;
export const TabsContextConsumer = TabsContext.Consumer;
//# sourceMappingURL=TabsContext.js.map